import {
  IBigQueryFirestoreModel,
  IBigQueryReffable,
  ITimestampedDimension,
} from './common';
import { IBigQueryContactable } from './contact';

export interface ILabDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    IBigQueryContactable,
    ITimestampedDimension {
  labJobTypes: IBigQueryLabJobType[];
}

export interface IBigQueryLabJobType extends IBigQueryFirestoreModel {
  name: string;
  cost: number;
}
